import { useNavigate } from "react-router-dom";
import GEMAuditionApplicationData from "../../js/gemAuditionApplicationData";
import {
  Navbar,
  Footer,
  Experience,
  MainHeading,
  HoverButton,
} from "../../components";
import AppStoreIcon from "../../assets/image/App_Store_2x.png";
import GooglePlayIcon from "../../assets/image/Google_Play_2x.png";

const GEMAuditionApplication = () => {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/gem-audition-form");
  };

  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-5">
        <div className="flex flex-col items-center xs:mt-3 sm:mt-3 lg:mt-6">
          <h4 className="font-unboundedBold text-secondary xs:text-base sm:text-base xl:text-2xl capitalize">
            Download the App
          </h4>
          <div className="flex items-center gap-7 xs:mt-4 sm:mt-4 lg:mt-6">
            <a
              href="https://apps.apple.com/us/app/gem-global/id6755765029"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all duration-300 transform hover:scale-105 shadow" 
            >
              <img
                src={AppStoreIcon}
                alt="Download on App Store"
                className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.geminc.gem"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all duration-300 transform hover:scale-105 shadow"
            >
              <img
                src={GooglePlayIcon}
                alt="Get it on Google Play"
                className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
              />
            </a>
          </div>
        </div>
        <MainHeading
          title={GEMAuditionApplicationData?.heroTitle}
          dis={GEMAuditionApplicationData?.heroSubTitle}
          disStyle={{ fontSize: 25, marginTop: 25 }}
          layout={"h-18 sm:h-20 lg:h-36"}
        />
        
        <div className="max-w-5xl m-auto xs:pt-2 sm:pt-4 lg:pt-8">
          {GEMAuditionApplicationData?.sections?.map((section, index) => (
            <div key={index} className="xs:pt-2 sm:pt-4 lg:pt-8">
              <h4 className="text-goldMetallic font-unboundedBold lg:text-xl leading-4 sm:leading-5 lg:leading-tight pb-1">
                {section?.title}
              </h4>
              <p className="text-secondary font-onestRegular lg:text-xl leading-4 sm:leading-5 lg:leading-tight" style={{fontSize: 25}}>
                {section?.description}
              </p>
            </div>
          ))}

          <div className="flex flex-col items-center justify-center text-center xs:pt-6 sm:pt-8 lg:pt-12 xs:pb-4 sm:pb-6 lg:pb-10">
            <h2 className="text-secondary font-unboundedBold uppercase lg:text-2xl leading-4 sm:leading-5 lg:leading-tight pb-2">
              {GEMAuditionApplicationData?.cta?.title}
            </h2>
            <p className="text-secondary font-onestRegular lg:text-xl leading-4 sm:leading-5 lg:leading-tight pb-4">
              {GEMAuditionApplicationData?.cta?.description}
            </p>
            <HoverButton
              onClick={handleApplyNow}
              extraClasses={
                "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
              }
              BtnTitle={GEMAuditionApplicationData?.cta?.btnTitle}
              BtnTitleClasses={
                "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
              }
            />
          </div>
        </div>
      </div>
      <Experience />
      <Footer />
    </div>
  );
};

export default GEMAuditionApplication;
